/**
 * Scrolls to the element with the ID 'scroll-to-element' after a delay.
 */
export const scrollToElement = (): void => {
  setTimeout(() => {
    const scrollTo = document.getElementById('scroll-to-element');

    if (scrollTo?.scrollIntoView)
      scrollTo.scrollIntoView({ behavior: 'smooth' });
  }, 500);
};
